import React, { useState, useEffect } from 'react';
import DefaultLayout from '../../layouts/DefaultLayout';
import TopNavigation from './TopNavigation';
import HeaderBG from '../../components/HeaderBG';
import SectionTitle from '../../components/SectionTitle';
import Filters from './Filters';
import TableNavigation from './TableNavigation';
import Table from './Table';
import Drawer from './Drawer';
import { Container } from 'semantic-ui-react';
import feathers from '../../services/feathers';
import swal from 'sweetalert';
import { pluralize } from '../../functions/common';

const Shippers = (props) => {
  const service = feathers.service('shippers');

  // States
  const [currentShipper, setCurrentShipper] = useState({});
  const [isBusy, setIsBusy] = useState(false);
  const [openPanel, setOpenPanel] = useState(false);
  const [data, setData] = useState();
  const [selection, setSelection] = useState([]);
  const [messageAction, setMessageAction] = useState();
  const [query, setQuery] = useState(null);

  // Effects
  useEffect(() => {
    const filter = () => {
      if (query) {
        getData();
      }
    }

    filter();
  }, [query]);

  // Functions
  const getData = async () => {
    if (query) {
      let data = [],
        result = [];

      try {
        setIsBusy(true);
        setSelection([]);

        // console.debug('query', JSON.stringify(query, null, 2));
        do {
          result = await service.find({
            query: {
              ...query,

              $skip: data.length
            }
          });

          data = data.concat(result.data);

          // console.debug('result', result);
        } while (data.length !== result.total);
      } catch (err) {
        console.error('Error', err);
        data = [];

        swal({
          title: 'Error',
          text: 'Failed get Shippers',
          icon: 'error',
          buttons: {
            cancel: 'Close'
          }
        });
      } finally {
        setData(data);
        setIsBusy(false);

        // refFilters && refFilters.current && refFilters.current.focus();
      }
    }
  };

  const openDrawer = (shipper) => {
    setCurrentShipper(shipper);
    setOpenPanel(true);
  };

  // Handles
  const handleCreateClick = () => {
    openDrawer({});
  };

  const handleEditClick = (shipper) => {
    openDrawer(shipper);
  };

  const handleDeleteClick = async () => {
    let success = false;
    const total = selection.length;

    try {
      let msg = `Do you want to delete ${total} ${pluralize(total, 'shipper')}?`;
      let confirmation = await swal(msg, {
        buttons: ['No', 'Yes'],
      });

      if (confirmation) {
        setIsBusy(true);
        setMessageAction('Deleting ...');
        const result = await service.remove(selection);

        if (result && result.length) {
          success = true;
        } else throw Error('Not found');
      }
    } catch (error) {
      // console.debug(error);
      await swal('Error', `Don't Delete selected ${pluralize(total, 'shipper')}`, 'error');
    } finally {
      setMessageAction();
      setIsBusy(false);

      if (success) {
        await swal('Done', 'Finished', 'success');

        setSelection([]);
        getData();
      }
    }
  };

  const handleClose = isSuccess => {
    setCurrentShipper({});
    setOpenPanel(false);

    isSuccess && getData();
  };

  return (
    <>
      <DefaultLayout
        currentPath={props.match.path}
        globalActions={<TopNavigation
          isBusy={isBusy}
          onCreateClick={handleCreateClick}
        />}
      >
        <HeaderBG />

        <Container>
          <SectionTitle>Shippers</SectionTitle>

          <Filters
            isBusy={isBusy}
            query={query}
            setQuery={setQuery}
          />

          <TableNavigation
            isBusy={isBusy}
            haveSelected={selection.length > 0}
            onDeleteClick={handleDeleteClick}
            messageAction={messageAction}
          />

          <Table
            data={data}
            onEditClick={handleEditClick}
            selection={selection}
            setSelection={setSelection}
          ></Table>
        </Container>
      </DefaultLayout>

      {openPanel ? (
        <Drawer
          openPanel={openPanel}
          onClose={handleClose}
          shipper={currentShipper}
        ></Drawer>
      ) : null}
    </>
  );
};

export default Shippers;